import { motion } from "framer-motion";
import { ClipboardList, UserCheck, LogIn, LineChart } from "lucide-react";

const steps = [
  {
    icon: ClipboardList,
    num: "01",
    title: "Submit Event Specs",
    desc: "Date, venue, capacity, and role breakdown — our form takes under 60 seconds.",
  },
  {
    icon: UserCheck,
    num: "02",
    title: "Custom Roster Blueprint",
    desc: "A dedicated staffing captain assigns certified, background-checked crew to every post.",
  },
  {
    icon: LogIn,
    num: "03",
    title: "Onsite Check-In & Briefing",
    desc: "Crew arrives 45 minutes early, in uniform, badged, and briefed on your venue playbook.",
  },
  {
    icon: LineChart,
    num: "04",
    title: "Live Telemetry & Audit",
    desc: "Real-time attendance logs during the event, plus one unified invoice after.",
  },
];

export default function HowItWorksSection() {
  return (
    <section id="how-it-works" className="py-20 sm:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="max-w-2xl"
        >
          <p className="text-xs uppercase tracking-[0.2em] font-mono-tactical font-semibold text-sky-400">
            How It Works
          </p>
          <h2 className="font-display mt-3 text-2xl sm:text-3xl lg:text-4xl font-extrabold uppercase tracking-tight text-white">
            From Booking to Encore in 4 Steps
          </h2>
        </motion.div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {steps.map((s, i) => (
            <motion.div
              key={s.num}
              initial={{ opacity: 0, y: 22 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              data-testid={`how-step-${i + 1}`}
              className="relative bg-[#131622] border border-white/10 rounded-md p-6 hover:border-sky-500/40 transition-colors duration-300"
            >
              <span className="font-mono-tactical text-4xl font-bold text-sky-500/25">
                {s.num}
              </span>
              <span className="absolute top-6 right-6 w-10 h-10 rounded-sm bg-sky-500/10 border border-sky-500/25 flex items-center justify-center">
                <s.icon className="w-5 h-5 text-sky-500" />
              </span>
              <h3 className="mt-4 font-display text-lg font-bold text-white">
                {s.title}
              </h3>
              <p className="mt-2 text-sm text-slate-400 leading-relaxed">
                {s.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
